module.exports = __webpack_public_path__ + "static/media/web-hd.3b9525a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/web-hd.mp4
// module id = DIxC
// module chunks = 0